<template>
  <div class="window new-payment-window" v-show="isVisible">
    <span class="close" title="Закрыть" @click="closeWindow"><img src="../image/cancel.svg"></span>
    <div class="window-title">Добавить операцию</div>
    <div class="form">
      <div class="form-block">
        <div class="fieldset">
          <label class="fieldset-title">Дата операции</label>
          <date-picker
                  v-model="date"
                  ref="datePicker"
                  format="DD.MM.YYYY"
                  lang="ru"
                  v-mask="'##.##.####'"
                  placeholder="__.__.____"
                  :clearable="false"
                  :first-day-of-week="1">
          </date-picker>
        </div>
        <div class="fieldset">
            <label class="fieldset-title">Время</label>
            <fieldset>
                <input type="time" v-model="time">
            </fieldset>
        </div>
        <div class="fieldset" v-show="showWorker">
          <label class="fieldset-title">ФИО рабочего</label>
          <fieldset>
            <model-select
              :options="workerOptions"
              v-model="selectedWorkerOption"
              placeholder=""/>
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Тип операции</label>
          <fieldset>
            <select v-model="selectedOperationType">
              <option v-for="operationType in operationTypes"
                      :value="operationType">{{ operationType.name }}</option>
            </select>
            <label v-show="showDebt"><input type="checkbox" v-show="showDebt" v-model="isDebt"><span>выдача залога</span></label>
          </fieldset>
        </div>
        <!--<div class="fieldset" v-show="showWorker">-->
          <!--<label class="fieldset-title">ID заявки</label>-->
          <!--<fieldset>-->
            <!--<input type="text" v-model="orderId" />-->
          <!--</fieldset>-->
        <!--</div>-->
        <div class="fieldset">
          <label class="fieldset-title">Способ расчета</label>
          <fieldset>
            <select v-model="isCash">
              <option :value="true">Наличный</option>
              <option :value="false">Безналичный</option>
            </select>
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Комментарий</label>
          <fieldset>
            <input type="text" v-model="comment" />
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Сумма, руб.</label>
          <fieldset>
            <input type="text" v-model="amount" />
          </fieldset>
        </div>
      </div>
      <div class="buttons">
        <button type="button" class="save-button" @click="addOperation">Добавить</button>
      </div>
    </div>
  </div>
</template>
<script>
  import {ModelSelect} from 'vue-search-select'
  import api from '@/api'
  import DatePicker from 'vue2-datepicker'
  import utils from '@/utils'
  import {mask} from 'vue-the-mask'

  export default {
  name: 'CashboxAddOperation',
  components: {
    ModelSelect,
    DatePicker
  },

  directives: {mask},

  props: ['isVisible', 'workers'],
  data () {
    return {
      date: utils.getDateWithoutTime(new Date()),
      time: utils.formatTime(new Date()),
      selectedOperationType: null,
      // orderId: null,
      isCash: true,
      isDebt: false,
      amount: null,
      comment: '',

      selectedWorkerOption: {
        value: '',
        text: ''
      }
    }
  },

  computed: {
    waitingApiRequestsCount () {
      return this.$store.getters.waitingApiRequestsCount
    },

    // Справочник типов операций
    operationTypes: {
      get () {
        return this.$store.getters.cashboxOperationTypes
      }
    },

    workerOptions: {
      get () {
        return this.workers
          //можно добавить операцию только к рабочим которые не уволены и не в черном списке
          .filter(worker => {
            return !worker.dismiss && !worker.inBlacklist
          })
          .sort((worker1, worker2) => {
            return (worker1.surname + ' ' + worker1.name) > (worker2.surname + ' ' + worker2.name)
          })
          .map(worker => {
            return {
              value: worker.id,
              text: utils.getFullName(worker.name, worker.surname, worker.patronymic)
            }
          })
      }
    },

    showWorker: {
      get () {
        return !this.selectedOperationType || !['cashbox_deposit', 'cashbox_withdrawal'].includes(this.selectedOperationType.code)
      }
    },

    showDebt: {
        get () {
            return !this.selectedOperationType || ['account_withdrawal'].includes(this.selectedOperationType.code)
        }
    }
  },

  watch: {
    isVisible (val) {
      if (val) {
        this.clearData()
      }
    }
  },

  methods: {
    clearData () {
      this.date = utils.getDateWithoutTime(new Date());
      this.selectedOperationType = this.operationTypes[0];
      // this.orderId = null;
      this.isCash = true;
      this.amount = null;
      this.comment = '';

      this.selectedWorkerOption = {
        value: '',
        text: ''
      }
    },

    addOperation () {
      if (this.waitingApiRequestsCount != 0) { return }

      if (!this.date) {
        alert('Заполните дату!');
        return
      }
      if (!this.time) {
          alert('Заполните поле "Время"');
          return
      }
      if (this.showWorker && !this.selectedWorkerOption.value) {
        alert('Выберите рабочего!');
        return
      }
      let amountNumber = Number(Number(this.amount.replace(',', '.')).toFixed(2));
      if (!amountNumber || amountNumber <= 0) {
        alert('Укажите корректную сумму!');
        return
      }

      let year = this.date.getFullYear();
      let month = this.date.getMonth();
      let day = this.date.getDate();
      let timeAsArray = this.time.split(':');
      let hours = timeAsArray[0];
      let minutes = timeAsArray[1];

      let dto = {
        date: new Date(year, month, day, hours, minutes).getTime(),
        type: {
          code: this.selectedOperationType.code,
          isDebt: ['account_withdrawal'].includes(this.selectedOperationType.code) ? this.isDebt : false
        },
        cash: this.isCash,
        amount: amountNumber,
        comment: this.comment
      };
      if (this.showWorker) {
        Object.assign(dto, {
          worker: {
            id: this.selectedWorkerOption.value
          }
          // orderId: this.orderId
        })
      }

      this.$store.dispatch('waitingApiRequestsCount', true)
        .then(() => {
          api
            .saveCashboxOperation(dto)
            .then(() => {
              this.$emit('operation-added');
              this.clearData();
              alert('Запись была добавлена')
              this.closeWindow()
            })
            .catch(err => alert(err))
            .finally(() => this.$store.dispatch('waitingApiRequestsCount', false))
        })
    },

    closeWindow () {
      this.$emit('close-window', false)
    },

    addDatePickerWatcher() {
      // нужен для того, чтобы по клику на энтер в дейтпикере проставлялась новая дата, а не предыдущая

      this.$watch(
        () => {
          return this.$refs.datePicker.userInput
        },
        (newVal, oldVal) => {
          let tmpValueForDatePicker = utils.spotNewValueForDatePicker(newVal, oldVal);
          if (tmpValueForDatePicker) {
            this.date = tmpValueForDatePicker;
            this.$refs.datePicker.popupVisible = false;
          } else if (tmpValueForDatePicker === null) {
            this.$refs.datePicker.userInput = '';
            this.$refs.datePicker.currentValue = null;
          }
        }
      );
    }
  },

    mounted() {
      this.addDatePickerWatcher();
    }
}
</script>
